import store from '@/store';

export const hasPermissions = (perms = []) => {
  const permissions = store.getters['user/permissions'];
  return perms.every((p) => (permissions.indexOf(p) >= 0));
};

export default {};
